import * as SHub_Constants from './SHub.Constants.js';
import * as SHub_API_Core from './SHub.API.Core.js';

class PublicProject {
    Authenticate = function () {
        // return SHub_API_Core.default.Get(SHub_Constants.default.SHAPP_API_URL + "api/v2/app/publicproject/authenticate/undefined", false, true, false);
        let forgeApiUrl = 'forge-hackathon'
        if (window.location.href.includes('localhost')) forgeApiUrl += '-dev'
        return SHub_API_Core.default.Get(SHub_Constants.default.CCTECH_API_URL + forgeApiUrl + "/get-token", false, true, false);
    };
}

export default PublicProject;